import React, { Component } from 'react';


class ChessControls extends Component {

  constructor(props) {
        super(props);

        this.state = { index: 0, buttonName: 'Go', interval: 15, showScore: 'none', scoreButtonName: 'Show Score'};
        this.nextMove = this.nextMove.bind(this);
        this.previousMove = this.previousMove.bind(this);
        this.start = this.start.bind(this);
        this.setMove = this.setMove.bind(this);
        this.go = this.go.bind(this);
        this.showScore = this.showScore.bind(this);
        this.showMove = this.showMove.bind(this);
    }

    goOrStop = 0;

  nextMove() {
    if(Object.keys(this.props.update.diagrams).length > (this.state.index + 1))
    {
       this.props.updateStateIndexFromChild(this.state.index + 1);
       this.setState({index : this.state.index + 1});
    }
  }

  previousMove() {
    if(0 < this.state.index)
    {
       this.setState({index : this.state.index - 1});
       this.props.updateStateIndexFromChild(this.state.index - 1);
    }
  }

  start() {
    this.setState({index : 0});
    this.props.updateStateIndexFromChild(0);
  }

  setMove(e,index){
    this.setState({index});
    this.props.updateStateIndexFromChild(index);
  }

  go() {

    if(this.state.buttonName == 'Go')
    {
       this.setState({buttonName : 'Stop'});
       this.goOrStop = setInterval(this.nextMove, 100*this.state.interval);
    }
    else if(this.state.buttonName == 'Stop')
    {
       this.setState({buttonName : 'Go'});
       clearInterval(this.goOrStop);
    }
  }

  showScore() {

    if(this.state.scoreButtonName == 'Show Score')
    {
       this.setState({scoreButtonName : 'Hide Score'});
       this.setState({showScore : 'block'});
    }
    else if(this.state.scoreButtonName == 'Hide Score')
    {
       this.setState({scoreButtonName : 'Show Score'});
       this.setState({showScore : 'none'});
    }
  }

  showMove(comment,index){
    let comment1 = '';
    let comment2 = '';
    let i = comment.indexOf(' ');
    if(i != -1)
    {
      comment1 = comment.substring(0,i);
      comment2 = comment.substring(i);
    }
    else {
      comment1 = comment;
    }
    return <div><span class="pointer" onClick={(e) => this.setMove(e,index)}>{comment1}&nbsp;</span><span>{comment2}&nbsp;</span></div>
  }

  onInput() {
    var input = document.getElementById("speedRange");
    var currentVal = 35 - input.value;
    this.setState({
      interval: currentVal
    })
          if(this.state.buttonName == 'Stop')
          {
               clearInterval(this.goOrStop);
               this.goOrStop = setInterval(this.nextMove, 100*currentVal);
          }
 }

 changeColor(){
    var colors = document.getElementsByName('squareColor');
    if (colors[0].checked == true)
    {
      this.props.updateStateColorFromChild('green');
    }
    else if (colors[1].checked == true)
    {
      this.props.updateStateColorFromChild('black');
    }
    else if (colors[2].checked == true)
    {
      this.props.updateStateColorFromChild('brown');
    }
 }

 changePieceType(){
    var pieceType = document.getElementsByName('pieceType');

    if (pieceType[0].checked == true)
    {
      this.props.updateStatePieceTypeFromChild('solid');
    }
    else if (pieceType[1].checked == true)
    {
      this.props.updateStatePieceTypeFromChild('transparent');
    }
    else if (pieceType[2].checked == true)
    {
      this.props.updateStatePieceTypeFromChild('image');
    }
  }

  getPrevious(id, max, min){
    if(id == min){
      return max;
    }
    return id - 1;
  }

  getNext(id, max, min){
    if(id == max){
      return min;
    }
    return id + 1;
  }

    render() {
        if(this.props.update != null)
        {
        var style = this.props.update.diagrams[this.state.index] == '' ? {display: 'none'} : {display: 'block'}
        const borderStyle = {border: '3px solid'};
        //console.log("showPartial: " + this.props.showPartial)
        if(this.props.showPartial == null)
        {
          return (
                <div>
                <div style={style} class="btn-group btn-group-justified">
    		           <button class="btn btn-primary" onClick={this.nextMove}>
    		               Next
    		           </button>
    		           <button class="btn btn-primary" onClick={this.previousMove}>
    		               Previous
    		           </button>
    		           <button class="btn btn-primary" onClick={this.start}>
    		               Start
    		           </button>
    		           <button class="btn btn-primary" onClick={this.go}>
    		               {this.state.buttonName}
    		           </button>
    		        </div>
    		        <br/>
    		        <p style={style, borderStyle}> {this.props.update.comments[this.state.index]} </p>
                            <div style={style}>
                                <label for="speedRange">Speed</label>
                                <input id="speedRange" type="range" min="0" max="30" step="5" defaultValue="20" onInput={this.onInput.bind(this)}/>
                            </div>
                            <div style={style}>
                                <label><input type="radio" id="green" name="squareColor" onInput={this.changeColor.bind(this)} />Green</label>
                                <label><input type="radio" id="black" name="squareColor" onInput={this.changeColor.bind(this)} />Black</label>
                                <label><input type="radio" id="brown" name="squareColor" onInput={this.changeColor.bind(this)} />Brown</label>
                            </div>
                            <div style={style}>
                                <label><input type="radio" id="solid" name="pieceType" onInput={this.changePieceType.bind(this)} />Solid</label>
                                <label><input type="radio" id="transparent" name="pieceType" onInput={this.changePieceType.bind(this)} />Transparent</label>
                                <label><input type="radio" id="image" name="pieceType" onInput={this.changePieceType.bind(this)} />Image</label>
                            </div>
                            <div style={style}>
                              <button class="btn btn-primary" onClick={this.showScore}>
      		                      {this.state.scoreButtonName}
      		                    </button>
                              <p style={{ display: this.state.showScore }}>Click on a move to show the position</p>
                              <p style={{ display: this.state.showScore }}>{Object.values(this.props.update.comments).map((comment, index) => this.showMove(comment, index))}</p>
                            </div>
                    </div>
                    );
                  }
                  else{
                    return (
                          <div>
                          <div style={style} class="btn-group btn-group-justified">
              		           <button class="btn btn-primary" onClick={this.nextMove}>
              		               Next
              		           </button>
              		           <button class="btn btn-primary" onClick={this.previousMove}>
              		               Previous
              		           </button>
              		           <button class="btn btn-primary" onClick={this.start}>
              		               Start
              		           </button>
              		           <button class="btn btn-primary" onClick={this.go}>
              		               {this.state.buttonName}
              		           </button>
              		        </div>
              		        <br/>
                                      <div style={style}>
                                          <label for="speedRange">Speed</label>
                                          <input id="speedRange" type="range" min="0" max="30" step="5" defaultValue="20" onInput={this.onInput.bind(this)}/>
                                      </div>
                                      <div style={style}>
                                          <label><input type="radio" id="green" name="squareColor" onInput={this.changeColor.bind(this)} />Green</label>
                                          <label><input type="radio" id="black" name="squareColor" onInput={this.changeColor.bind(this)} />Black</label>
                                          <label><input type="radio" id="brown" name="squareColor" onInput={this.changeColor.bind(this)} />Brown</label>
                                      </div>
                                      <div style={style}>
                                          <label><input type="radio" id="solid" name="pieceType" onInput={this.changePieceType.bind(this)} />Solid</label>
                                          <label><input type="radio" id="transparent" name="pieceType" onInput={this.changePieceType.bind(this)} />Transparent</label>
                                          <label><input type="radio" id="image" name="pieceType" onInput={this.changePieceType.bind(this)} />Image</label>
                                      </div>
                              </div>
                        );
                  }
                }
                else
            		return (
            		   <div>Nothing</div>
            );
    }
}

export default ChessControls;
